import type { ResolvedNode } from '../../../../vendor/agentplace-a2ui/walker.ts';

export const EXPLORE_CONTENT_ACTION = 'Tell me more';

/** Only displayed content belongs here. Never pass form values or a whole data model. */
export function contentExplorationContext(
  node: Pick<ResolvedNode, 'id' | 'component' | 'props'>,
  selection: Record<string, unknown>,
  surrounding: Record<string, unknown> = {},
): Record<string, unknown> {
  const displayedContext = { ...surrounding };
  for (const key of ['message', 'explanation', 'description', 'subtitle', 'caption']) {
    if (key === 'description' && 'explanation' in node.props) continue;
    if (key === 'subtitle' && 'message' in node.props) continue;
    if (typeof node.props[key] === 'string') {
      displayedContext[key] = node.props[key];
    }
  }
  return {
    nodeId: node.id,
    component: node.component,
    title: displayHeading(node.props),
    selection,
    surrounding: displayedContext,
  };
}

function displayHeading(props: Record<string, unknown>): string | undefined {
  const value = props.highlight ?? props.question ?? props.title;
  return typeof value === 'string' ? value : undefined;
}

/** Links, controls and text selection keep their own behavior inside readable content. */
export function isContentExplorationClick(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) {
    return false;
  }
  if (
    target.closest(
      'a, button, input, select, textarea, label, summary, audio, video, canvas, ' +
        '[role="button"], [role="link"], [role="checkbox"], [role="radio"], [role="switch"], ' +
        '[role="slider"], [role="combobox"], [role="tab"], [role="textbox"], [contenteditable]',
    )
  ) {
    return false;
  }
  return !target.ownerDocument.getSelection()?.toString();
}
